import React from 'react'
import { safeLazy } from '../utils/SafeLazy/SafeLazy'
import ChunkLoader from '../components/ChunkLoader/ChunkLoader'

export const AGENT_MANAGER_PATH = '/agent-manager'

const AgentManagerPage = safeLazy(() => import('../pages/AgentManager/AgentManagerPage'))

export const AGENT_MANAGER_ROUTES = [
	{
		path: AGENT_MANAGER_PATH,
		element: (
			<ChunkLoader>
				<AgentManagerPage />
			</ChunkLoader>
		),
	},
]
